import { Timestamp } from 'firebase-admin/firestore';
import { ChannelGroup, GroupFilterMap } from '..';
import { isSpecificPersonal } from './isPersonal';

export function isSupport<TTime = Timestamp>(
  channelGroup: ChannelGroup<keyof GroupFilterMap, TTime>,
): channelGroup is ChannelGroup<'Support', TTime> {
  return isSpecificPersonal(channelGroup, 'support');
}
